import { ProgramProductDetails } from '../../../ProgramStore/Types';
import UpcomingSessions from './UpcomingSessions';

interface Props {
  productDetails: ProgramProductDetails;
}

function LiveSessions({ productDetails }: Props) {
  return (
    <UpcomingSessions
      label="Upcoming live sessions"
      sessions={productDetails.liveSessions}
      moreCount={productDetails.moreLiveSessionsCount}
    />
  );
}

export default LiveSessions;
